import { Routes } from '@angular/router';
import {permissions} from '../../permissions';
import {AuthGuardService as AuthGuard} from "../../auth-guard.service";
import {NgxPermissionsGuard} from "ngx-permissions";
import {OrderLinesComponent} from "./order-lines.component";

export const routes: Routes = [{
    path: 'order-lines',
    component: OrderLinesComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Orders Lines',
        permissions: {
            only: [permissions.PURCHASE_ORDER_READ]
        }
    }
},];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/order-lines/order-lines.routing.ts